import store from '@/store'

export function translate (translationKey) {
  let a = store.state.data.Translations[translationKey]
  // console.log(this.$store)
  if (a) {
    // console.log(a[store.state.app.language])
    return a[store.state.app.language]
  } else {
    return ''
  }
}



// WEBPACK FOOTER //
// ./src/utils/translate.js